import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePage.css';
import { setPageMeta } from '../utils/seo';

const TechRecruitment = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta(
      'Tech Recruitment | HRCONSOL',
      'Specialized tech recruitment for startups and enterprises: developers, AI/ML, DevOps, product, cybersecurity and more. 3,000+ roles filled across MENA.'
    );
  }, []);

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Tech Recruitment – Powering the Next Generation of Innovators</h1>
          <p className="subtitle">At HRCONSOL, we specialize in connecting top-tier Tech Talent with leading startups, software houses, and enterprises across Pakistan and MENA. From full-stack developers to UI/UX designers, we bridge the gap between innovation and execution — helping companies scale faster, smarter, and stronger.</p>
        </div>
      </div>

      <div className="container">
        <div className="service-content">
          <div className="service-section">
            <h2>Why HRCONSOL for Tech Recruitment?</h2>
            <p>Our Tech Recruitment division helps startups and established organizations hire right, reduce turnover, and accelerate product development with verified and skilled professionals.</p>
            <p>With over <strong>3,000+ tech positions closed</strong> and a <strong>95% client satisfaction rate</strong>, our impact speaks for itself — we don't just recruit talent; we build digital success stories.</p>
          </div>

          <div className="service-section">
            <h2>Scope of Services (Premium Features)</h2>
            <p>We offer end-to-end, tech-driven recruitment with premium add-ons that set us apart:</p>
            <div className="process-steps">
              <div className="step">
                <h3><i className="fas fa-user-tie"></i> Dedicated Tech Recruiters</h3>
                <p>Specialized in Software, Cloud, and Product hiring.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-robot"></i> AI-Powered Screening</h3>
                <p>For skill and cultural fit assessment.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-clipboard-check"></i> Developer Skill Tests</h3>
                <p>Verified portfolio evaluation and hands-on assessments.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-database"></i> Pre-Vetted Talent Pool</h3>
                <p>Access to 10,000+ IT Professionals ready to hire.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-clock"></i> Fast-Track Hiring</h3>
                <p>From job brief to onboarding within 10–14 days.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-rocket"></i> Startup Recruitment</h3>
                <p>Flexible and budget-friendly hiring plans for startups.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-bullhorn"></i> Employer Branding</h3>
                <p>Strategic consultation to attract top digital talent.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-gift"></i> Free Job Marketing</h3>
                <p>Across platforms like LinkedIn, GitHub, Stack Overflow.</p>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Tech Positions We Hire For</h2>
            <p>Our expertise covers all major roles across software houses, IT firms, and startups:</p>
            <ul className="benefits-list">
              <li><i className="fas fa-code"></i> Software Developers (Front-End, Back-End, Full Stack)</li>
              <li><i className="fas fa-mobile-alt"></i> Mobile App Developers (iOS, Android, Flutter, React Native)</li>
              <li><i className="fas fa-paint-brush"></i> UI/UX Designers & Product Designers</li>
              <li><i className="fas fa-vial"></i> QA Engineers & Test Automation</li>
              <li><i className="fas fa-server"></i> DevOps Engineers & Cloud Architects</li>
              <li><i className="fas fa-tasks"></i> Project Managers & Scrum Masters</li>
              <li><i className="fas fa-shield-alt"></i> Cybersecurity & Network Engineers</li>
              <li><i className="fas fa-brain"></i> Data Scientists, AI/ML Engineers</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Industries & Startup Sectors We Serve</h2>
            <p>We empower businesses across multiple technology-driven sectors:</p>
            <ul className="benefits-list">
              <li><i className="fas fa-cloud"></i> SaaS & FinTech Startups</li>
              <li><i className="fas fa-shopping-cart"></i> E-Commerce & Retail Tech</li>
              <li><i className="fas fa-heartbeat"></i> HealthTech & EdTech</li>
              <li><i className="fas fa-truck"></i> Logistics & IoT Solutions</li>
              <li><i className="fas fa-laptop-code"></i> Software Development Houses</li>
              <li><i className="fas fa-building"></i> Enterprise IT & Digital Transformation</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Recruitment Impact That Delivers Results</h2>
            <ul className="benefits-list">
              <li>
                <span className="benefit-heading">3,000+ Tech Positions Closed</span>
                <span className="benefit-subheading">across Pakistan, UAE & MENA</span>
              </li>
              <li>
                <span className="benefit-heading">95% Client Retention Rate</span>
                <span className="benefit-subheading">with repeat hiring</span>
              </li>
              <li>
                <span className="benefit-heading">40% Faster Hiring Time</span>
                <span className="benefit-subheading">compared to traditional recruiters</span>
              </li>
              <li>
                <span className="benefit-heading">90% Successful Candidate Retention</span>
                <span className="benefit-subheading">post-probation</span>
              </li>
            </ul>
          </div>

          <div className="service-cta">
            <h2>Ready to Build Your Tech Team?</h2>
            <p>Let's connect you with the best tech talent in the market.</p>
            <button onClick={() => navigate('/#contact')} className="cta-button">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechRecruitment;

